var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStrategy1 = function SvgStrategy1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 84 85"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    y: 0.857,
    fill: "#204969",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M56.998 41.452a.97.97 0 0 0-.288-.748.97.97 0 0 0-.757-.286c-.257.015-6.361.399-10.45 4.443-1.075 1.064-1.888 2.265-2.512 3.462v-26.12l4.252 4.207a1 1 0 0 0 .7.287 1 1 0 0 0 .701-.287.97.97 0 0 0 0-1.386l-5.943-5.88a.997.997 0 0 0-1.4 0l-5.944 5.88a.97.97 0 0 0 0 1.386.997.997 0 0 0 1.4 0l4.253-4.207v16.18c-.623-1.198-1.437-2.398-2.511-3.462-4.09-4.043-10.194-4.428-10.451-4.442a1.03 1.03 0 0 0-.756.286.97.97 0 0 0-.29.748c.015.255.404 6.294 4.492 10.339 3.196 3.162 7.613 4.083 9.516 4.344v9.827c-.624-1.198-1.437-2.398-2.512-3.46-4.088-4.045-10.194-4.43-10.451-4.443a1.02 1.02 0 0 0-.756.285.97.97 0 0 0-.29.749c.015.254.403 6.293 4.492 10.339 3.196 3.162 7.612 4.083 9.516 4.344v3.04c0 .542.444.98.99.98.547 0 .991-.438.991-.98V56.135c1.904-.26 6.32-1.182 9.516-4.343 4.09-4.046 4.477-10.085 4.492-10.34"
  })));
};
export default SvgStrategy1;